import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
export const UsersSlice = createSlice({
  name: "UsersState",
  initialState: {
    showModal: false,
    users: [],
    initialUsersData: [],
    usersDataIsLoading: false,
  },
  reducers: {
    setUsersDataIsLoading: (state, action) => {
      state.usersDataIsLoading = action.payload;
    },
    showNewUserModal: (state) => {
      state.showModal = true;
    },
    hideNewUserModal: (state) => {
      state.showModal = false;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setInitialUsersData: (state, action) => {
      state.initialUsersData = action.payload;
    },
    deleteUser: (state, action) => {
      const { uuid } = action.payload;
      // Use Lodash to filter out the user with the specified uuid
      state.users = _.filter(state.users, (user) => user.uuid !== uuid);
    },
    updateUser: (state, action) => {
      const { uuid, updatedProperties } = action.payload;
      state.users = state.users.map((user) =>
        user.uuid === uuid
          ? { ...user, ...updatedProperties } // Merge existing user with updated properties
          : user
      );
    },
  },
});
export const {
  showNewUserModal,
  hideNewUserModal,
  updateUser,
  setUsers,
  setInitialUsersData,
  deleteUser,
  setUsersDataIsLoading,
} = UsersSlice.actions;
export default UsersSlice.reducer;
